import { Grid, styled, Tooltip } from '@mui/material';
import { Box, InputLabel } from '../../index';
import TextField from '@mui/material/TextField';
import { tooltipClasses, Checkbox } from '@mui/material';
import { TooltipProps } from '@mui/material/Tooltip';

export const StyledGrid = styled(Grid)(({ theme }) => ({
  paddingBottom: theme.spacing(3)
}));
export const StyledTooltip = styled(
  ({ className, ...props }: TooltipProps) => (
    <Tooltip classes={{ tooltip: className, arrow: className, popper: className }} {...props} />
  ),
  { name: 'SalesForceID_info' }
)(({ theme }) => ({
  [`&.${tooltipClasses.tooltip}`]: {
    padding: 0,
    fontWeight: theme.typography.fontWeightLight,
    maxWidth: '420px',
    background: theme.palette.grey[600],
    border: `${theme.spacing(0.25)} solid ${theme.palette.primary.main}`
  },
  [`&.${tooltipClasses.arrow}`]: {
    border: 'none',
    fontSize: theme.typography.h4.fontSize,
    '&:before': {
      border: `${theme.spacing(0.25)} solid ${theme.palette.primary.main}`,
      background: theme.palette.grey[600]
    }
  },
  [`&.${tooltipClasses.popper}`]: {
    padding: theme.spacing(1),
    width: '420px'
  }
}));
export const InputLabelStyled = styled(InputLabel, {
  shouldForwardProp: prop => prop !== 'isDisabled'
})<{ isDisabled?: boolean }>(({ theme, isDisabled }) => ({
  fontSize: theme.typography.body3.fontSize,
  lineHeight: theme.typography.body2.lineHeight,
  height: 36,
  color: isDisabled ? theme.palette.grey[300] : undefined,
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  alignItems: 'center',
  paddingBottom: theme.spacing(1)
}));
export const TextFieldStyled = styled(TextField, {
  shouldForwardProp: prop => prop !== 'hasError'
})<{ hasError?: boolean }>(({ theme, hasError }) => ({
  width: '100%',
  '& input': {
    padding: theme.spacing(1.25, 2),
    color: theme.palette.grey[100],
    fontSize: '14px'
  },
  '& .Mui-disabled fieldset': {
    border: `1px solid ${theme.palette.grey[400]} !important`
  },
  '& p.MuiFormHelperText-root:not(.Mui-error)': {
    userSelect: 'none',
    display: hasError ? 'visible' : 'none'
  }
}));
export const HiddenCheckbox = styled(Checkbox, { name: 'hidden_checkbox' })(({ theme }) => ({
  display: 'none'
}));
export const Item = styled(Box)(({ theme }) => ({
  ...theme.typography.body2,
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(0, 3, 2.25, 1.5),
  textAlign: 'left',
  color: theme.palette.text.secondary,
  width: '100%'
}));
export const ButtonRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  width: '100%',
  '& button': {
    marginLeft: theme.spacing(1.25)
  }
}));
